const AUTOMATION_CURRENT_ALLOCATION_TABLE_ID = 'AUTOMATION_CURRENT_ALLOCATION_TABLE_ID';
const AUTOMATION_UPCOMING_ALLOCATION_TABLE_ID = 'AUTOMATION_UPCOMING_ALLOCATION_TABLE_ID';
const AUTOMATION_PURSUIT_ALLOCATION_TABLE_ID = 'AUTOMATION_PURSUIT_ALLOCATION_TABLE_ID';
const AUTOMATION_PAST_ALLOCATION_TABLE_ID = 'AUTOMATION_PAST_ALLOCATION_TABLE_ID';

export { AUTOMATION_CURRENT_ALLOCATION_TABLE_ID, AUTOMATION_UPCOMING_ALLOCATION_TABLE_ID, AUTOMATION_PURSUIT_ALLOCATION_TABLE_ID, AUTOMATION_PAST_ALLOCATION_TABLE_ID };
